<div class="ccm_usage">
    <div class="spinner-content" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div class="ccm_usage_left full_width">
        <h4 *ngIf="!loading">Duration of Diabetes</h4>
        <p [innerHTML]="dataInsight?.duration_text | safeHtml" *ngIf="!loading"></p>
        <div class="canvas">
            <canvas id="durationDiabetesChart" height="250" width="200"></canvas>
        </div>

    </div>

</div>